
// src/reducers/diaries-reducer.js

// スマートフォンとWebで挙動を変えるため
import { isSmartPhone } from '../helpers/agent-type'

import {
  FETCH_DIARIES,
  FETCH_DIARIES_REQUESTED,
  FETCH_DIARIES_COMPLETED,
  FETCH_DIARIES_FAILED,
  FLUSH_UNREAD_DIARIES,
  FLUSH_UNREAD_DIARIES_REQUESTED,
  FLUSH_UNREAD_DIARIES_COMPLETED,
  FLUSH_UNREAD_DIARIES_FAILED,
  POST_OR_UPDATE_DIARY,
  POST_OR_UPDATE_DIARY_REQUESTED,
  POST_OR_UPDATE_DIARY_COMPLETED,
  POST_OR_UPDATE_DIARY_FAILED,
  DELETE_DIARY,
  DELETE_DIARY_REQUESTED,
  DELETE_DIARY_COMPLETED,
  DELETE_DIARY_FAILED,
  MARK_DIARY_READ,
  MARK_DIARY_READ_REQUESTED,
  MARK_DIARY_READ_COMPLETED,
  MARK_DIARY_READ_FAILED,
  CLEAR_DIARIES,
  LOAD_DIARY,
  MERGE_NEW_DIARIES,
} from '../actions/diaries'

import {
  FETCH_HOME_DIARIES,
  FETCH_HOME_DIARIES_REQUESTED,
  FETCH_HOME_DIARIES_COMPLETED,
  FETCH_HOME_DIARIES_FAILED,
} from '../actions/home-diaries'

import {
  POST_COMMENT_COMPLETED,
  PUT_COMMENT_COMPLETED,
  DELETE_COMMENT_COMPLETED,
} from '../actions/comments'

import {
  LIKE_DIARY_COMPLETED,
  LIKE_COMMENT_COMPLETED,
  DELETE_LIKE_COMPLETED,
} from '../actions/likes'

import {
  TRANSLATE_DIARY_COMPLETED,
  TRANSLATE_COMMENT_COMPLETED,
} from '../actions/translate'

import { mergeArray, deleteArray, updateArray, getArray } from '../helpers/store'
import findIndex from 'lodash/findIndex'
import reduce from 'lodash/reduce'
import map from 'lodash/map'

const initialState = {
  isPosting: false,
  isPostFailed: false,
  isRequesting: false,
  groups: {}, // isFetching, isFetchFailed, items, newItems, hasMore
}

function updateGroup(groups, group_id, group) {
  let _group = Object.assign({}, groups[group_id], group)
  return Object.assign({}, groups, { [group_id]: _group })
}

export default function diariesReducer(state = initialState, action = {}) {
  let groups

  switch(action.type) {
  case FETCH_DIARIES_REQUESTED:
  case FETCH_HOME_DIARIES_REQUESTED:
    return Object.assign({}, state, {
      groups: updateGroup(state.groups, action.group_id, {
        isFetching: true,
        isFetchFailed: false,
      })
    })

  case FLUSH_UNREAD_DIARIES_REQUESTED:
  case DELETE_DIARY_REQUESTED:
  case MARK_DIARY_READ_REQUESTED:
    return Object.assign({}, state, {
      isRequesting: true,
    })

  case POST_OR_UPDATE_DIARY_REQUESTED:
    return Object.assign({}, state, {
      isPosting: true,
      isPostFailed: false,
    })

  case FETCH_DIARIES_FAILED:
  case FETCH_HOME_DIARIES_FAILED:
    return Object.assign({}, state, {
      groups: updateGroup(state.groups, action.group_id, {
        isFetching: false,
        isFetchFailed: true,
      })
    }) || state

  case FLUSH_UNREAD_DIARIES_FAILED:
  case DELETE_DIARY_FAILED:
  case MARK_DIARY_READ_FAILED:
    return Object.assign({}, state, {
      isRequesting: false,
    })

  case POST_OR_UPDATE_DIARY_FAILED:
    return Object.assign({}, state, {
      isPosting: false,
      isPostFailed: true,
    })

  case FETCH_DIARIES_COMPLETED:
  case FETCH_HOME_DIARIES_COMPLETED:
    return Object.assign({}, state, {
      groups: updateGroup(state.groups, action.group_id, {
        isFetching: false,
        isFetchFailed: false,
        items: action.offset > 0 && state.groups[action.group_id] ? mergeArray('diary_id', state.groups[action.group_id].items, action.results) : action.results,
        newItems: action.offset == 0 ? [] : state.groups[action.group_id].newItems,
        hasMore: action.results.length == 10,
      })
    })

  case FLUSH_UNREAD_DIARIES_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      groups: updateGroup(state.groups, action.group_id, {
        items: action.results,
      })
    })

  case POST_OR_UPDATE_DIARY_COMPLETED:
    return Object.assign({}, state, {
      isPosting: false,
      isPostFailed: false,
      groups: updateGroup(state.groups, action.group_id, {
        items: mergeArray('diary_id', state.groups[action.group_id].items, [action.results], 'prepend')
      })
    })

  case DELETE_DIARY_COMPLETED:
    groups = reduce(state.groups, (r, group, id)=> {
      let index = findIndex(group.items, (item)=> item.diary_id == action.results.diary_id)
      if (index >= 0) {
        group.items = deleteArray('diary_id', group.items, action.results.diary_id)
      }
      r[id] = group
      return r
    }, {})
    return Object.assign({}, state, {
      isRequesting: false, groups
    })

  case MARK_DIARY_READ_COMPLETED:
  case POST_COMMENT_COMPLETED:
  case PUT_COMMENT_COMPLETED:
  case DELETE_COMMENT_COMPLETED:
  case LIKE_DIARY_COMPLETED:
  case LIKE_COMMENT_COMPLETED:
  case DELETE_LIKE_COMPLETED:
    groups = reduce(state.groups, (r, group, id)=> {
      const index = findIndex(group.items, (item)=> item.diary_id == action.results.diary_id)
      if (index >= 0) {
        let items = group.items.concat()
        let _group = group.items[index].group
        let item = Object.assign({}, action.results)
        item.group = _group
        items[index] = item
        group.items = items
      }
      r[id] = group
      return r
    }, {})
    return Object.assign({}, state, {
      isRequesting: false, groups
    })

  case CLEAR_DIARIES:
    if (action.group_id) {
      let groups = Object.assign({}, state.groups)
      delete groups[action.group_id]
      return Object.assign({}, state, { groups })
    } else
      return initialState

  case LOAD_DIARY:
    if (!state.groups[action.group_id])
      return state

    if (action.deleted) {
      return Object.assign({}, state, {
        groups: updateGroup(state.groups, action.group_id, {
          items: deleteArray('diary_id', state.groups[action.group_id].items, action.diary.diary_id)
        })
      })
    }
    else if (action.appending) {
      //if (isSmartPhone && (!action.own_post || getArray('diary_id', state.items, action.diary.diary_id)))
      if (isSmartPhone && !action.own_post)
        // スマホの場合で、自分自身の投稿でないappendingな場合はnewItemsに受信した投稿をためておく
        return Object.assign({}, state, {
          groups: updateGroup(state.groups, action.group_id, {
            newItems: mergeArray('diary_id', state.groups[action.group_id].newItems, [action.diary], 'prepend')
          })
        })
      else
        return Object.assign({}, state, {
          groups: updateGroup(state.groups, action.group_id, {
            items: mergeArray('diary_id', state.groups[action.group_id].items, [action.diary], 'prepend')
          })
        })
    }
    else {
      if (state.groups[action.group_id].items && state.groups[action.group_id].items.find((d)=> d.diary_id == action.diary.diary_id) ||
          state.groups[action.group_id].newItems && state.groups[action.group_id].newItems.find((d)=> d.diary_id == action.diary.diary_id))
        return Object.assign({}, state, {
          groups: updateGroup(state.groups, action.group_id, {
            items: mergeArray('diary_id', state.groups[action.group_id].items, [action.diary], 'discard'),
            newItems: state.groups[action.group_id].newItems && mergeArray('diary_id', state.groups[action.group_id].newItems, [action.diary], 'discard') || [],
          })
        })
      else
        return state
    }

  case MERGE_NEW_DIARIES:
    if (state.groups[action.group_id])
      return Object.assign({}, state, {
        groups: updateGroup(state.groups, action.group_id, {
          items: mergeArray('diary_id', state.groups[action.group_id].items, state.groups[action.group_id].newItems, 'prepend'),
          newItems: [],
        })
      })
    else
      return state

  case TRANSLATE_DIARY_COMPLETED:
    if (state.groups[action.group_id])
      return Object.assign({}, state, {
        groups: updateGroup(state.groups, action.group_id, {
          items: updateArray('diary_id', state.groups[action.group_id].items, action.diary_id, 'attach_json', action.results.attach_json),
        })
      })
    else
      return state

  case TRANSLATE_COMMENT_COMPLETED:
    if (state.groups[action.group_id]) {
      let diary = getArray('diary_id', state.groups[action.group_id].items, action.diary_id)
      if (!diary) return state
      let comments = diary.comments && map(diary.comments, (comment)=> {
        if (comment.comment_id == action.comment_id)
          return Object.assign({}, comment, { attach_json: action.results.attach_json })
        else {
          let sub_comments = comment.comments && map(comment.comments, (sub_comment)=> {
            if (sub_comment.comment_id == action.comment_id)
              return Object.assign({}, sub_comment, { attach_json: action.results.attach_json })
            else
              return sub_comment
          }) || undefined
          return Object.assign({}, comment, { comments: sub_comments })
        }
      }) || undefined
      return Object.assign({}, state, {
        groups: updateGroup(state.groups, action.group_id, {
          items: updateArray('diary_id', state.groups[action.group_id].items, action.diary_id, 'comments', comments),
        })
      })
    }
    else
      return state

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/diaries-reducer.js